import { render, staticRenderFns } from "./report-face15.vue?vue&type=template&id=56795f67&scoped=true&"
import script from "./report-face15.vue?vue&type=script&lang=ts&"
export * from "./report-face15.vue?vue&type=script&lang=ts&"
import style0 from "./report-face15.vue?vue&type=style&index=0&id=56795f67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56795f67",
  null
  
)

export default component.exports